import React, { Component } from "react";
import GolfStatusLogUpdate from "./GolfStatusLogUpdate";

class GolfStatusLogTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      golfstatuslog: []
  }
}
  componentDidMount() {
    fetch("/golfstatuslog")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        if (data.golfstatuslog.length > 0)
          this.setState({ golfstatuslog: data.golfstatuslog });
      });
  }

  render() {
    
    return (
      <div>
        <h2> History</h2>
        <ul>
          {this.state.golfstatuslog.map(golfstatusupdate => (
            <GolfStatusLogUpdate
              key={golfstatusupdate.timestamp}
              golfstatusupdate={golfstatusupdate}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default GolfStatusLogTable;
